import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { useQuery } from "@tanstack/react-query";
import { offlineQueue } from "@/lib/offlineQueue";
import { WifiOff, Wifi } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export function OfflineIndicator() {
  const { isOnline } = useOnlineStatus();

  const { data: queueCount = 0 } = useQuery({
    queryKey: ["offline-queue-count"],
    queryFn: async () => {
      const queue = await offlineQueue.getAll();
      return queue.length;
    },
    refetchInterval: 2000,
  });

  if (isOnline && queueCount === 0) return null;

  return (
    <Badge 
      variant={isOnline ? "default" : "destructive"}
      className="flex items-center gap-2"
    >
      {isOnline ? (
        <>
          <Wifi className="h-3 w-3" />
          Syncing {queueCount}...
        </>
      ) : (
        <>
          <WifiOff className="h-3 w-3" />
          Offline {queueCount > 0 && `• ${queueCount} queued`}
        </>
      )}
    </Badge>
  );
}
